import React, { Component } from "react";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { utcToLocal } from "../../utils/dateConvert";

class DeviceTable extends Component {
  renderSortHeader = (label, sortKey) => {
    const { onSort, sortDirection, sortKey: activeSortKey } = this.props;
    const active = activeSortKey === sortKey;
    const iconClass = active && sortDirection === "desc"
      ? "fa fa-sort-down"
      : active
        ? "fa fa-sort-up"
        : "fa fa-sort";

    return (
      <button
        className={`device-sort-button ${active ? "active" : ""}`}
        onClick={() => onSort(sortKey)}
        type="button"
      >
        {label}
        <i className={iconClass}></i>
      </button>
    );
  };

  renderStatus = (status) => {
    const statusText = status || "-";
    const statusClass = statusText.toString().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

    return (
      <span className={`device-status device-status-${statusClass}`}>
        {statusText}
      </span>
    );
  };

  render() {
    const { deviceList } = this.props;

    return (
      <Table className="device-table" responsive>
        <thead>
          <tr>
            <th>{this.renderSortHeader("Name", "name")}</th>
            <th>{this.renderSortHeader("Asset", "assetName")}</th>
            <th>{this.renderSortHeader("Customer", "customerName")}</th>
            <th>{this.renderSortHeader("IMEI", "imei")}</th>
            <th>{this.renderSortHeader("SIM", "simNumber")}</th>
            <th>{this.renderSortHeader("Type/Model", "type")}</th>
            <th>{this.renderSortHeader("Network", "networkType")}</th>
            <th>{this.renderSortHeader("Tag", "tag")}</th>
            <th>{this.renderSortHeader("Status", "deviceStatus")}</th>
            <th>{this.renderSortHeader("Software", "software")}</th>
            <th>{this.renderSortHeader("Firmware", "firmware")}</th>
            <th>{this.renderSortHeader("Last Connected", "lastMessageTime")}</th>
            <th>{this.renderSortHeader("Updated", "dbUpdated")}</th>
            <th>{this.renderSortHeader("Created", "dbCreated")}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {deviceList.length === 0 && (
            <tr>
              <td className="device-empty" colSpan="15">
                No devices match your search or type filter.
              </td>
            </tr>
          )}
          {deviceList.map((device, index) => (
            <tr key={device.id || index}>
              <td><strong>{device.name || "-"}</strong></td>
              <td>{device.assetName || "-"}</td>
              <td>
                <a
                  className="device-customer-link"
                  onClick={() =>
                    localStorage.setItem(
                      "customer",
                      JSON.stringify({
                        customerId: device.customerId,
                        customerName: device.customerName,
                      })
                    )
                  }
                  href={`/devices?customerId=${device.customerId}&customerName=${device.customerName}`}
                >
                  {device.customerName || "-"}
                </a>
              </td>
              <td>{device.imei || "-"}</td>
              <td>{device.simNumber || "-"}</td>
              <td>{device.type || "-"}</td>
              <td>{device.networkType || "-"}</td>
              <td>{device.tag || "-"}</td>
              <td>{this.renderStatus(device.deviceStatus)}</td>
              <td>{device.software || "-"}</td>
              <td>{device.firmware || "-"}</td>
              <td>{device.lastMessageTime ? utcToLocal(device.lastMessageTime) : "-"}</td>
              <td>{device.dbUpdated ? utcToLocal(device.dbUpdated) : "-"}</td>
              <td>{device.dbCreated ? utcToLocal(device.dbCreated) : "-"}</td>
              <td className="device-actions">
                <Link to={`/editDevice/${device.id}`}>Edit</Link>
                <Link to={`/deviceDetails/${device.id}`}>Details</Link>
                <Link to={`/deleteDevice/${device.id}`}>Delete</Link>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  }
}

export default DeviceTable;
